import React from 'react'
import PropTypes from 'prop-types'
import { LogosArea } from 'LiveBoard/components/shared/LogosArea'
import { PasswordContainer, PasswordImage } from './types/Password'
import { EmailVerificationContainer, EmailVerificationImage } from './types/EmailVerification'
import get from 'lodash/get'

import style from './style.css.scss'

const AUTHORIZATION_COMPONENTS = {
  password: {
    authComponent: PasswordContainer,
    imageComponent: PasswordImage
  },
  email_verification: {
    authComponent: EmailVerificationContainer,
    imageComponent: EmailVerificationImage
  }
}

class Authorization extends React.Component {
  getComponentsToDisplay() {
    return AUTHORIZATION_COMPONENTS[this.props.authorizationType] || {}
  }

  render() {
    const config = {
      logo: get(this, 'props.config.logo'),
      icon: get(this, 'props.config.icon'),
      secondaryLogo: get(this, 'props.config.secondary_logo'),
      privacyMessage: get(this, 'props.config.privacy_message')
    }

    const displayedComponents = this.getComponentsToDisplay()

    const AuthComponent = displayedComponents.authComponent
    const ImageComponent = displayedComponents.imageComponent

    return (
      <div className='authorization-app'>
        <div className="auth-section">
          {
            this.props.config &&
            <div className="logos-section">
              <LogosArea
                config={config}
                withPadding={true} />
            </div>
          }
          { AuthComponent &&
            <AuthComponent locale={this.props.locale} privacyMessage={config.privacyMessage} />
          }
        </div>
        <div className="authorization-page-image-box">
          { ImageComponent && <ImageComponent/> }
        </div>
      </div>
    )
  }
}

Authorization.propTypes = {
  config: PropTypes.object,
  locale: PropTypes.string,
  authorizationType: PropTypes.string
}

export default Authorization
